// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zlnlO","colBig":"styles_colBig__18lO1","colSmall":"styles_colSmall__MeQ1T","shopifyNameWrapper":"styles_shopifyNameWrapper__3OazJ"};